// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  width: 100%;
  margin-bottom: 6px;
  padding: 10px;
  margin: 8px 0px;
  --padding-start: 0 !important;
  --ion-safe-area-right: 0 !important;
}

.checkbox-price {
  color: #b5b5b5;
}

.hidden {
  visibility: hidden;
}

.price {
  color: var(--ion-color-subtitle);
  font-size: 12px;
  font-family: AppFontBold, sans-serif;
}

.qty__btn {
  width: 24px;
  height: 24px;
  margin: 0 !important;
  box-shadow: none;
  --box-shadow: none;
}
.qty__btn button {
  box-shadow: unset !important;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 17px;
  color: white;
}
.qty .qty-number {
  margin: 0 4px;
  text-align: center;
  min-width: 15px;
  color: var(--ion-color-primary);
}

ion-checkbox {
  margin: 0 12px 0 0;
}

app-tag {
  display: inline-block;
}

ion-item {
  background: #ffffff;
  border: 0.5px solid #e2dcd5;
  border-radius: 10px;
}

ion-label {
  font-size: 14px !important;
  font-family: Tusker, sans-serif !important;
  color: var(--ion-color-primary) !important;
}

.name-info-block {
  display: flex;
  align-self: center;
  flex-direction: column;
  justify-content: flex-start;
  width: 53%;
}
.name-info-block h3 {
  font-size: 14px;
  font-family: AppFont, sans-serif !important;
}
.name-info-block span {
  font-family: Tusker, sans-serif !important;
  color: var(--ion-color-primary);
}

.circle-wrap {
  width: 25px;
  height: 25px;
  position: absolute;
  left: -10px;
  top: 10px;
  transform: translateY(-50%);
  z-index: 99;
}

.full-width {
  width: 100%;
  position: relative;
}

.icon_pfand {
  min-width: 45px;
  margin-top: 3px;
}

.measurement {
  margin-left: 5px;
}

.content-only {
  display: inline-block;
  position: relative;
  margin-left: 5px;
  width: 20px;
}
.content-only ion-icon {
  position: absolute;
  bottom: -4px;
  left: 0;
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

.text_wrap {
  text-align: left;
  text-wrap: wrap;
  white-space: normal;
  word-break: break-word;
}

.price_wrapper_block {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  margin-right: 4px;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 9px;
  color: #9f9f9f;
  text-align: right;
  padding-top: 7px;
}

.deposit_text {
  font-size: 14px;
  font-family: Tusker, sans-serif;
  color: #878787;
}

.brand_image {
  height: 26px;
  width: 39px;
  object-fit: contain;
}

.wrap-sor {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.wrap-sor .text {
  width: 30px;
}

.name_wrapper {
  width: 100%;
  display: flex;
  align-items: flex-start;
}
.name_wrapper .option-name-span {
  width: 75%;
}
.name_wrapper ion-icon {
  margin: 4px auto 0;
  width: 22px;
  height: 22px;
}

.qty-row {
  width: 47%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-multiple/article-option-group-multiple.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,mCAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EAEE,gCAAA;EACA,eAAA;EACA,oCAAA;AAAF;;AAIE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAGI;EACE,4BAAA;AADN;AAII;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;AAFN;AAME;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;AAJJ;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,qBAAA;AALF;;AAOA;EACE,mBAAA;EACA,2BAAA;EACA,mBAAA;AAJF;;AAMA;EACE,0BAAA;EACA,0CAAA;EAEA,0CAAA;AAJF;;AAMA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;AAHF;AAIE;EACE,eAAA;EACA,2CAAA;AAFJ;AAIE;EACE,0CAAA;EAEA,+BAAA;AAHJ;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AAJF;;AAOA;EACE,WAAA;EACA,kBAAA;AAJF;;AAMA;EACE,eAAA;EAEA,eAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAJF;AAME;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,+BAAA;EACA,YAAA;EACA,WAAA;AAJJ;;AAQA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AALF;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;AAJF;;AAMA;EACE,gCAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAHF;;AAKA;EAEE,eAAA;EACA,+BAAA;EACA,cAAA;AAHF;;AAKA;EACE,YAAA;EAGA,WAAA;EACA,mBAAA;AAJF;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AAHF;AAIE;EACE,WAAA;AAFJ;;AAMA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AAHF;AAKE;EACE,UAAA;AAHJ;AAME;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAJJ;;AAQA;EACE,UAAA;AALF","sourcesContent":["ion-item {\n  width: 100%;\n  margin-bottom: 6px;\n  padding: 10px;\n  margin: 8px 0px;\n  --padding-start: 0 !important;\n  --ion-safe-area-right: 0 !important;\n}\n\n.checkbox-price {\n  color: #b5b5b5;\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.price {\n\n  color: var(--ion-color-subtitle);\n  font-size: 12px;\n  font-family: AppFontBold, sans-serif;\n}\n\n.qty {\n  &__btn {\n    width: 24px;\n    height: 24px;\n    margin: 0 !important;\n    box-shadow: none;\n    --box-shadow: none;\n\n    button {\n      box-shadow: unset !important;\n    }\n\n    span {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      height: 17px;\n      color: white;\n    }\n  }\n\n  .qty-number {\n    margin: 0 4px;\n    text-align: center;\n    min-width: 15px;\n    color: var(--ion-color-primary);\n  }\n}\n\nion-checkbox {\n  margin: 0 12px 0 0;\n}\n\napp-tag {\n  display: inline-block;\n}\nion-item {\n  background: #ffffff;\n  border: 0.5px solid #e2dcd5;\n  border-radius: 10px;\n}\nion-label {\n  font-size: 14px !important;\n  font-family: Tusker, sans-serif !important;\n\n  color: var(--ion-color-primary) !important;\n}\n.name-info-block {\n  display: flex;\n  align-self: center;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 53%;\n  h3 {\n    font-size: 14px;\n    font-family: AppFont, sans-serif !important;\n  }\n  span {\n    font-family: Tusker, sans-serif !important;\n\n    color: var(--ion-color-primary);\n  }\n}\n\n.circle-wrap {\n  width: 25px;\n  height: 25px;\n  position: absolute;\n  left: -10px;\n  top: 10px;\n  transform: translateY(-50%);\n  z-index: 99;\n}\n\n.full-width {\n  width: 100%;\n  position: relative;\n}\n.icon_pfand {\n  min-width: 45px;\n\n  margin-top: 3px;\n}\n\n.measurement {\n  margin-left: 5px;\n}\n\n.content-only {\n  display: inline-block;\n  position: relative;\n  margin-left: 5px;\n  width: 20px;\n\n  ion-icon {\n    position: absolute;\n    bottom: -4px;\n    left: 0;\n    color: var(--ion-color-primary);\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.text_wrap {\n  text-align: left;\n  text-wrap: wrap;\n  white-space: normal;\n  word-break: break-word;\n}\n.price_wrapper_block {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  flex-direction: column;\n  margin-right: 4px;\n}\n.measurment_text {\n  font-family: AppFont, sans-serif;\n  font-size: 9px;\n  color: #9f9f9f;\n  text-align: right;\n  padding-top: 7px;\n}\n.deposit_text {\n\n  font-size: 14px;\n  font-family: Tusker, sans-serif;\n  color: #878787;\n}\n.brand_image {\n  height: 26px;\n \n\n  width: 39px;\n  object-fit: contain;\n}\n.wrap-sor {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  .text {\n    width: 30px;\n  }\n}\n\n.name_wrapper {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n\n  .option-name-span {\n    width: 75%;\n  }\n\n  ion-icon {\n    margin: 4px auto 0;\n    width: 22px;\n    height: 22px;\n  }\n}\n\n.qty-row {\n  width: 47%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
